var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentcolor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.9 22.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9.7H7.6c-.6 0-1 .4-1 1v19.8c0 .6.4 1 1 1h3.3c.6 0 1-.4 1-1V1.7c0-.5-.4-1-1-1zM7.6 4h2.2v.5H7.6V4zM11 21.1H7.6v-1.9H11v1.9zm0-17.6H7.6V3H11v.5zm0-1H7.6v-.4H11v.4zM4.3.7H1c-.6 0-1 .4-1 1v19.8c0 .6.4 1 1 1h3.3c.6 0 1-.4 1-1V1.7c0-.5-.5-1-1-1zM1 3h1.7v.5H1V3zm0 1h2.8v.5H1V4zm3.4 17H1v-1.9h3.5V21zm0-18.5H1v-.4h3.5v.4zM22.9 20L18.1.7C18 .2 17.5-.1 17 0l-3.2.8c-.6.1-.9.7-.8 1.2l4.7 19.2c.1.5.7.8 1.2.7l3.2-.8c.6-.1.9-.6.8-1.1zM14 2.1l3.4-.8.1.5-3.4.8-.1-.5zm.3 1l3.4-.8.1.5-3.3.8-.2-.5zm.3 1.3l-.1-.4 3.3-.8.2.4-3.4.8zm4 16.2l-.4-1.8 3.3-.8.4 1.8-3.3.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.82113da5.svg";
export { ForwardRef as ReactComponent };